import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ACTION_COLUMN, Align } from '@ptg-shared/controls/grid';
import { select, Store } from '@ngrx/store';
import { filter, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ptg-shared/components';
import { ConfirmPopupComponent } from '@ptg-shared/controls/confirm-popup/confirm-popup.component';
import { ConfirmType } from '@ptg-shared/constance/confirm-type.const';
import { DatePipe } from '@angular/common';
import { ColumnSetListComponent } from '@ptg-member/components/column-set-list/column-set-list.component';
import { AdhocReportState } from '@ptg-member/store/reducers/adhoc-report.reducer';
import { getTemplatesSelector, removeReportTemplateSelector } from '@ptg-member/store/selectors/adhoc-report.selector';
import { ReportTemplate } from '@ptg-processing/types/models/report-template.model';
import { clearRemoveReportTemplateStateAction, getTemplatesAction, removeReportTemplateAction } from '@ptg-member/store/actions/adhoc-report.actions';
import { Router } from '@angular/router';
import { STATE } from '@ptg-shared/constance';
import { getDateString } from '@ptg-shared/utils/string.util';

@Component({
  selector: 'ptg-adhoc-report-template-list',
  templateUrl: './adhoc-report-template-list.component.html',
  styleUrls: ['./adhoc-report-template-list.component.scss']
})
export class AdhocReportTemplateListComponent extends BaseComponent {
  ACTION_COLUMN = ACTION_COLUMN;
  columns = [
    {
      name: 'columnName',
      editable: true,
      truncate: true,
    },
    {
      name: ACTION_COLUMN,
      align: Align.Right,
      width: '50px',
    },
  ];
  listTemplates: (ReportTemplate & { valueDescription?: string, columnName?: string })[] = [];
  isLoading: boolean = true;
  constructor(
    public dialog: MatDialog,
    public dialogRefColumn: MatDialogRef<ColumnSetListComponent>,
    public datePipe: DatePipe,
    private store: Store<AdhocReportState>,
    public readonly router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this._getTemplatesSelector();
    this._removeTemplateSelector();
    this.store.dispatch(getTemplatesAction());
  }


  onCancel() {
    this.dialogRefColumn.close();
  }

  onUpdateTemplate(data?: ReportTemplate) {
    this.router.navigateByUrl(`/member/adhoc-report/designer/${data?.id}`);
    this.dialogRefColumn.close();
  }

  onRemoveTemplate(data: ReportTemplate) {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      panelClass: 'confirm-popup',
      data: {
        type: ConfirmType.Cancel,
        title: 'Confirmation',
        cancelButtonTitle: 'No',
        text: `Are you sure you want to remove this Template?`,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(removeReportTemplateAction({ request: { templateId: data?.id } }));
      }
    });
  }


  _getTemplatesSelector() {
    this.store
      .select(getTemplatesSelector)
      .pipe(
        filter((res) => !!res && !res.isLoading),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((response) => {
        if (response?.payload) {
          this.isLoading = false;
          this.listTemplates = response.payload.templates.map((item) => {
            return { ...item, valueDescription: `${item.createdBy} ${this.datePipe.transform(getDateString(item.updatedTime), 'MM/dd/yyyy h:mm a')}` }
          });
        }
      });
  }

  _removeTemplateSelector() {
    this.store
      .pipe(select(removeReportTemplateSelector),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res) => {
        if (res?.state)
          if (res.state === STATE.SUCCESS) {
            this.store.dispatch(getTemplatesAction());
          }
        this.store.dispatch(clearRemoveReportTemplateStateAction());
      });
  }
}
